import Typography from "../../../components/Typography/Typography";
import Loader from "../../../components/Loader/Loader";
import styles from "./LoginSuccess.module.scss";

const LoginSuccess = () => {
	return (
		<div className={styles.loginSuccessContainer}>
			<div className={styles.loginSuccessTitle}>
				<Typography variant="h5">Redireccionando...</Typography>
			</div>
			<Loader></Loader>
		</div>
	);
};

export default LoginSuccess;
